import React, { useState } from "react";
import {Accordion, Button, Grid, Icon} from "semantic-ui-react";
import { convertToDollar, convertToPercentString, convertToYesNo } from "../../Helpers";
import "../../styles/summary.scss";
import "../../styles/main.scss";
import { convertFirstToUppercase } from "../../helpers/GlobalHelper";

const getSummaryField = (type, value ) => {
  if ( value || value === 0 || value === false) {
    switch(type) {
      case "dollar":
        if (!isNaN(value)) {
          value = parseFloat(value);
        }

        return convertToDollar(value);
      case "convert percent":
        if (!isNaN(value)) {
          value = parseFloat(value);
        }

        return convertToPercentString(value);
      case "percent":
        return value + "%";
      case "month":
        return `${value} month${value !== 0 ? "s" : ""}`;
      case "bool":
        return convertToYesNo(value);
      case "date":
        return new Date(value).toLocaleDateString();
      case "length":
        return value.length;
      case "acre":
        return `${value} ${convertFirstToUppercase(type)}`;
      case "sqft":
        return `${value} ${convertFirstToUppercase(type)}`;
      default:
        return value;
    }
  }
  else {
    return "N/A";
  }
};

const SummaryField = ({ type, value}) => {
  return (
    <span>
      {getSummaryField(type, value)}
    </span>
  );
};

const BCAccordion = ({ ...props }) => {
  const [activeAccordions, setActiveAccordions] = useState([0] as number[]);

  const handleActiveAccordions = (id) => {
    const foundAccordionIndex = activeAccordions.indexOf(id);
    if (foundAccordionIndex > -1) {
      activeAccordions.splice(foundAccordionIndex, 1);
    }
    else {
      activeAccordions.push(id);
    }
    setActiveAccordions([...activeAccordions]);
  };
  const activeIndex = 0;
  return (
    <Accordion className="summary-accordion">
      <Accordion.Title
        className={props.titleClass ? props.titleClass : "summary-accordion-title"}
        style={props.setColor ? props.setColor : void 0}
        active={activeAccordions.includes(props.accordion.index)}
        onClick={() => handleActiveAccordions(activeIndex)}
      >
        <Icon name='dropdown' /> 
        {props.accordion.title}
      </Accordion.Title>
      <Accordion.Content active={activeAccordions.includes(props.accordion.index)}>
          {props.accordion.otherContent ? props.accordion.otherContent : <Grid className="summary-grid" columns={3} divided='vertically'>
            {props.accordion.content && props.accordion.content.map((item, i) => {
              if (item.condition) {
                return null;
              }
              else {
                return (
                  <Grid.Row key={`bc-accordion-row-${i}`}>
                    <Grid.Column width={1}>
                      <Button className="gmr-edit-button" icon onClick={item.onClick} disabled={props.disabled}>
                      <Icon name='edit outline' size="large" />
                      </Button>
                    </Grid.Column>
                    <Grid.Column className="label-format vertical-center" width={7}>
                      {item.label}
                    </Grid.Column>
                    <Grid.Column className="label-format vertical-center" key={"summary_field_column_" + i} width={8}>
                      {item && <SummaryField type={item.type} value={item.value} /> }
                    </Grid.Column>
                  </Grid.Row>
                );   
              }
          })}
        </Grid>}
      </Accordion.Content>
    </Accordion>
  );
};

export default BCAccordion;